import clsx from 'clsx';
import React from 'react';
import { ButtonV2 } from 'components';
import { ButtonSize } from 'constants/button';
import { Intent } from 'constants/ui';
export const PaginationBlockButton = ({ buttonContainerClassname, children, ...props }) => (React.createElement("div", { className: clsx('pagination-bar-button', { [buttonContainerClassname]: !!buttonContainerClassname }) },
    React.createElement(ButtonV2, { intent: Intent.NEUTRAL, isIconButton: !children, size: ButtonSize.SMALL, type: "button", ...props }, children)));
